import { render, staticRenderFns } from "./Canal.vue?vue&type=template&id=02009889&scoped=true&"
import script from "./Canal.vue?vue&type=script&lang=js&"
export * from "./Canal.vue?vue&type=script&lang=js&"
import style0 from "./Canal.vue?vue&type=style&index=0&id=02009889&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02009889",
  null
  
)

export default component.exports